export default __webpack_public_path__ + "static/media/onboarding_organize_ad_2.a0c42b33.png";